import { Injectable, inject } from '@angular/core';
import { TeamWorkloadState } from '../../states/team-workload.state';
import { GetTeamWorkloadStateResult } from './get-team-workload-state.result';

@Injectable({ providedIn: 'root' })
export class GetTeamWorkloadStateUseCase {
  private readonly _state = inject(TeamWorkloadState);

  public execute(): GetTeamWorkloadStateResult {
    return {
      summary: this._state.summary,
      overCapacityMembers: this._state.overCapacityMembers,
      overdueMembers: this._state.overdueMembers,
      atRiskMembers: this._state.atRiskMembers,
      timeOffMembers: this._state.timeOffMembers,
      teamWorkloads: this._state.teamWorkloads,
      rebalancingProposals: this._state.rebalancingProposals,
      viewMode: this._state.viewMode,
      includeClosedCases: this._state.includeClosedCases,
      loading: this._state.loading,
      loadingRebalancing: this._state.loadingRebalancing,
      error: this._state.error,
      teamBalancingCandidates: this._state.teamBalancingCandidates,
      loadingTeamBalancingCandidates: this._state.loadingTeamBalancingCandidates,
      proposalGroups: this._state.proposalGroups,
      effectiveProposals: this._state.effectiveProposals,
      removedProposalIds: this._state.removedProposalIds,
      dismissedProposalIds: this._state.dismissedProposalIds,
      applyingProposals: this._state.applyingProposals,
      collapsedProposalTeams: this._state.collapsedProposalTeams,
      proposalOverrides: this._state.proposalOverrides,
    };
  }
}
